import { render, staticRenderFns } from "./CommandPalette.vue?vue&type=template&id=a7bb1b38&scoped=true"
import script from "./CommandPalette.vue?vue&type=script&lang=js"
export * from "./CommandPalette.vue?vue&type=script&lang=js"
import style0 from "./CommandPalette.vue?vue&type=style&index=0&id=a7bb1b38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7bb1b38",
  null
  
)

export default component.exports